var _desc, _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProfileIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "10px",
    height: "10px",
    viewBox: "0 0 10 10",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icon") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M5,5.58333334 C7.74750001,5.58333334 9.66666669,7.02241668 9.66666669,9.08333334 L9.66666669,9.08333334 L9.66666669,9.66666669 L0.333333314,9.66666669 L0.333333314,9.08333334 C0.333333314,7.02241668 2.25249999,5.58333334 5,5.58333334 Z M5,0.333333314 C6.28683334,0.333333314 7.33333334,1.37983332 7.33333334,2.66666666 C7.33333334,3.9535 6.28683334,5 5,5 C3.71316666,5 2.66666666,3.9535 2.66666666,2.66666666 C2.66666666,1.37983332 3.71316666,0.333333314 5,0.333333314 Z",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Ideation",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Combined-Shape"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Icon-color",
    fill: "#FFFFFF",
    mask: "url(#mask-2)",
    x: -2,
    y: -2,
    width: 14,
    height: 14
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileIcon);
export default __webpack_public_path__ + "static/media/Profile Icon.abb5a915e3a74029d2339225c537ecba.svg";
export { ForwardRef as ReactComponent };